import Vue from 'vue'
import Router from 'vue-router'
// import login from '@/components/pages/login/login'
import redirectLogin from '@/components/pages/login/redirectLogin'
import loginHome from '@/components/pages/login/loginHome'
import index from '@/components/pages/myIndex/index'
import myHome from '@/components/pages/myHome/myHome'
import myErrorMessageList from '@/components/pages/myHome/myErrorMessageList'
import myUpHistoryRecord from '@/components/pages/myHome/myUpHistoryRecord'
import mySystemList from '@/components/pages/mySystemMessager/mySystemList'
import mySystemMessager from '@/components/pages/mySystemMessager/mySystemMessager'
import mySupersuPro from '@/components/pages/mySystemMessager/mySupersuPro'
import mySupersuProList from '@/components/pages/mySystemMessager/mySupersuProList'
import myAPIGate from '@/components/pages/mySystemMessager/myAPIGate'
import myAPIGateList from '@/components/pages/mySystemMessager/myAPIGateList'
import myLogList from '@/components/pages/mySystemMessager/myLogList'
import myLogHomeDetail from '@/components/pages/mySystemMessager/myLogHomeDetail'
import myValidationDetail from '@/components/pages/mySystemMessager/myValidationDetail'
import myDnload from '@/components/pages/myDnload/myDnload'
import myDnloadHome from '@/components/pages/myDnload/myDnloadHome'
import myDnloadHomeDetail from '@/components/pages/myDnload/myDnloadHomeDetail'
import myDnloadHomeTwoDetail from '@/components/pages/myDnload/myDnloadHomeTwoDetail'
import myOneSuCriberList from '@/components/pages/myDnload/myOneSuCriberList'
import myAllSuCriberList from '@/components/pages/myDnload/myAllSuCriberList'
import myOneDnloadTaskList from '@/components/pages/myDnload/myOneDnloadTaskList'
import myAllDnloadTaskList from '@/components/pages/myDnload/myAllDnloadTaskList'
import emailDownload from '@/components/pages/myDnload/emailDownload'
import thirdlogin from '@/components/pages/login/thirdlogin'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/thirdlogin',
      name: 'thirdlogin',
      component: thirdlogin
    },
    {
      path: '/loginHome',
      name: 'loginHome',
      component: loginHome
    },
    {
      path: '/',
      redirect: '/myHome'
    },
    {
      path: '/redirectLogin',
      name: 'redirectLogin',
      component: redirectLogin
    },
    {
      path: '/emailDownload',
      name: 'emailDownload',
      component: emailDownload
    },
    {
      path: '/index',
      name: 'index',
      redirect: '/myHome',
      component: index,
      children: [
        {
          path: '/myHome',
          name: 'myHome',
          component: myHome
        },
        {
          path: '/myErrorMessageList',
          name: 'myErrorMessageList',
          component: myErrorMessageList
        },
        {
          path: '/myUpHistoryRecord',
          name: 'myUpHistoryRecord',
          component: myUpHistoryRecord
        },
        {
          path: '/mySystemMessager',
          name: 'mySystemMessager',
          redirect: '/mySystemList',
          component: mySystemMessager,
          children: [
            {
              path: '/mySystemList',
              name: 'mySystemList',
              component: mySystemList
            },
            {
              path: '/myValidationDetail',
              name: 'myValidationDetail',
              component: myValidationDetail
            },
            {
              path: '/mySupersuPro',
              name: 'mySupersuPro',
              component: mySupersuPro
            },
            {
              path: '/mySupersuProList',
              name: 'mySupersuProList',
              component: mySupersuProList
            },
            {
              path: '/myAPIGate',
              name: 'myAPIGate',
              component: myAPIGate
            },
            {
              path: '/myAPIGateList',
              name: 'myAPIGateList',
              component: myAPIGateList
            },
            {
              path: '/myLogList',
              name: 'myLogList',
              component: myLogList
            },
            {
              path: '/myLogHomeDetail',
              name: 'myLogHomeDetail',
              component: myLogHomeDetail
            }
          ]
        },
        {
          path: '/myDnload',
          name: 'myDnload',
          redirect: '/myDnloadHome',
          component: myDnload,
          children: [
            {
              path: '/myDnloadHome',
              name: 'myDnloadHome',
              component: myDnloadHome
            },
            {
              path: '/myDnloadHomeDetail',
              name: 'myDnloadHomeDetail',
              component: myDnloadHomeDetail
            },
            {
              path: '/myDnloadHomeTwoDetail',
              name: 'myDnloadHomeTwoDetail',
              component: myDnloadHomeTwoDetail
            },
            {
              path: '/myOneSuCriberList',
              name: 'myOneSuCriberList',
              component: myOneSuCriberList
            },
            {
              path: '/myAllSuCriberList',
              name: 'myAllSuCriberList',
              component: myAllSuCriberList
            },
            {
              path: '/myOneDnloadTaskList',
              name: 'myOneDnloadTaskList',
              component: myOneDnloadTaskList
            },
            {
              path: '/myAllDnloadTaskList',
              name: 'myAllDnloadTaskList',
              component: myAllDnloadTaskList
            }
          ]
        }
      ]
    }
  ],
  linkActiveClass: 'is-active'
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js